import React from 'react'
import { Link } from 'react-router-dom'







const Card=(props) =>{
  return (
    <>
   
    <div className='container text-center pt-3'>
    <div className="card1 " style={{width: "18rem"}}>
  <img id='card' src={props.imgCard} className="card-img-top" alt=""/>
  <div className="card-body">
    <h5 className="card-title">{props.Cardtittle}</h5>
    <p className="card-text">{props.Cardname}</p>

   
    <Link to="/Displayform" relative="path">
    <button type="button" className="btn btn-primary" >
    {props.Read}
</button>
    </Link>



  </div>
</div>
      
    </div>
    </>
  )
}

export default Card
